export const getGeoLocURL = () => '/api/geocoding/?latlng=';

export const isAppointmentForm = (target: HTMLElement): boolean => {
    const isStandardAppointmentForm  = window.location.href.match(/demande-de-rendez-vous/);
    if (isStandardAppointmentForm !== null ||
        target.closest('[data-express-form-type="express-appointment"]') ||
        target.closest('[name^="express_appointment"]')
    ) {
        return true;
    }

    return false;
}
